import React from 'react';
import { currencyFormat } from '../../util';

const Detalle = (props) => {
  const { detalle } = props;
  // console.log(detalle);

  const getImpuesto = (impuestos = []) => {
    let monto = 0;
    let tarifa = '';
    impuestos.forEach((i) => {

      if (i.Exoneracion !== null && i.Monto >= i.Exoneracion.MontoExoneracion) {
        monto += i.Monto - i.Exoneracion.MontoExoneracion;
      }
      else {
        monto += i.Monto
      }

      if (tarifa.length > 0) {
        tarifa = tarifa + `, ${i.Tarifa}%`;
      }
      else {
        tarifa = `${i.Tarifa}%`;
      }

    });
    if (monto === 0 && tarifa.length === 0) {
      tarifa = 'Exento';
    }
    return (<div className="impuestos"><span>{currencyFormat(monto)}</span> <span className="tarifa-impuesto">{tarifa}</span></div>);
  }

  const getExonerado = (impuestos = []) => {
    let monto = 0;
    let porcentajeExo = '';
    impuestos.forEach((i) => {
      if (i.Exoneracion !== null) {
        monto += i.Exoneracion.MontoExoneracion;

        if (porcentajeExo.length > 0) {
          porcentajeExo = porcentajeExo + `, ${i.Exoneracion.TarifaExonerada}%`;
        }
        else {
          porcentajeExo = `${i.Exoneracion.TarifaExonerada}%`;
        }

      }
    });
    return (<div className="impuestos"><span>{currencyFormat(monto)}</span> <span className="tarifa-impuesto">{porcentajeExo}</span></div>);
  }

  return (
    <div className="detalle-section">
      <table className="ui compact table">
        <thead>
          <tr>
            <th>Cod. Prod - Cabys</th>
            <th>Cantidad</th>
            <th>Descripción</th>
            <th>Precio unitario</th>
            <th>Impuestos</th>
            <th>Exonerado</th>
            <th>Sub-Total</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {detalle.map((item, index) => (
            <tr key={index}>
              <td><span>{item.CodigoComercial?.Codigo}</span></td>
              <td><span>{item.Cantidad}</span></td>
              <td><span>{item.Detalle}</span></td>
              <td><span>{currencyFormat(item.PrecioUnitario)}</span></td>
              <td><span>{getImpuesto(item.Impuestos?.Impuesto)}</span></td>
              <td><span>{getExonerado(item.Impuestos?.Impuesto)}</span></td>
              <td><span>{currencyFormat(item.SubTotal)}</span></td>
              <td><span className="total-linea">{currencyFormat(item.MontoTotalLinea)}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
};

export default Detalle;